module.exports = {"title":"","content":"18+ New players only. Min 1st dep £20, max bonus £500. 25x wagering, max convertible restrictions and T&Cs apply. {{ link }}"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/alert.json
// module id = 624
// module chunks = 247 1471